import { Component, OnInit } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { Article } from 'src/app/models/article';
import { ExpenseService } from 'src/app/services/expense.service';
import { ExpenseType } from 'src/app/models/expense-type';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UomSap } from 'src/app/models/uom-sap';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
export class ArticleComponent implements OnInit {
  public articles:Article[] = [];
  public articlesTemp:Article[] = [];
  public uoms:UomSap[]= [];
  public expenseTypes:ExpenseType[] = [];
  public loading = false;
  public article:Article = new Article();
  public expand:boolean = false;

  public actEditArt:boolean = true;
  public actAddArt:boolean = true;
  public actDeleteArt:boolean = true;

  //Pagination
  public page:number = 1;
  public pagination:number = 25;

  //Searching
  public find:string = '';

  constructor(private articleServ:ArticleService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private expServ:ExpenseService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.getArticles();
    this.expServ.getExpenseTypes().then(types => this.expenseTypes = types.filter(exp => exp.type != 'Viaje' && exp.name != 'Nómina Especial' && exp.name != 'Sueldos Base' && exp.name != 'Subsidio al Empleo' && exp.name != 'Retención de Nómina'));
    this.actEditArt = this.authService.can("update-article");
    this.actDeleteArt = this.authService.can("destroy-article");
    this.actAddArt = this.authService.can("store-article");
  }

  getArticles() {
    this.loading = true;
    this.articleServ.getArticles().then( response => {
      this.articles = response;
      this.filter();
      this.loading = false;
      if(this.uoms.length == 0){
        this.getUoms();
      }
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  filter(){
    this.utl.search(this.articles, ['id', 'name', 'measure_unit'], this.find, 'id', articles => this.articlesTemp = articles);
  }

  getUoms(){
    this.loading = true;
    this.articleServ.getUoms().then( response =>{
      this.uoms = response;
      this.loading = false;
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  selectUom(){
    if(this.article.uom_entry){
      let data = this.uoms.find(e => e.uomEntry == this.article.uom_entry);
      this.article.uom_entry = data.uomEntry
      this.article.uom_code = data.uomCode;
    }
  }

  modalAddArticle(modal) {
    this.article = new Article();
    this.modalService.open(modal, { size: 'lg' });
  }

  modalUpdateArticle(modal, _article: Article){
    this.article = new Article();
    this.article = _article;
    if(this.article.uom_entry){
      let data = this.uoms.find(e => e.uomEntry == this.article.uom_entry);
      this.article.uom_entry = data.uomEntry
      this.article.uom_code = data.uomCode;
    }
    this.modalService.open(modal, { size: 'lg' });
  }

  modalDeleteArticle(modal, _article: Article){
    this.article = _article;
    this.modalService.open(modal, { size: 'lg' });
  }

  async updateArticle() {
    try {
      this.loading = true;
      await this.articleServ.putArticle(this.article);
      await this.getArticles();
      this.modalService.dismissAll();
      this.loading = false;
      this.article = new Article();
      this.toastr.successToastr('El artículo fue actualizado correctamente', '', { enableHTML: true });
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async storeArticle() {
    try {
      this.loading = true;
      await this.articleServ.postArticle(this.article);
      await this.getArticles();
      this.modalService.dismissAll();
      this.loading = false;
      this.article = new Article();
      this.toastr.successToastr('El artículo se ha creado correctamente', '', { enableHTML: true });
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async deleteArticle() {
    try {
      this.loading = true;
      let article = await this.articleServ.deleteArticle(this.article);
      await this.getArticles();
      this.loading = false;
      this.article = new Article();
      this.modalService.dismissAll();
      this.toastr.successToastr('El artículo fue eliminado correctamente', '', { enableHTML: true });
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

}
